/** Shared caution border for dirty cell overlays and inline input highlights. */
export const DIRTY_HIGHLIGHT_BORDER_CLASS = 'border-2 border-solid border-ckds-base-caution';
